module.exports = __webpack_public_path__ + "img/changeAllocation-1.ec2377a.png";